import { InMemoryCache } from '@apollo/client'
import { AdditionalService, PriceRange, ResourceAvailabilityRq } from '../api.generated'

export default function createInMemoryCache(): InMemoryCache {
  return new InMemoryCache({
    typePolicies: {
      RqOutput: {
        fields: {
          resources: {
            merge(_existing = [], incoming: ResourceAvailabilityRq[]) {
              return [...(incoming ?? [])]
            },
          },
        },
      },
      Rate: {
        fields: {
          chargesRate: {
            merge(_existing = [], incoming: ResourceAvailabilityRq[]) {
              return [...(incoming ?? [])]
            },
          },
          priceRanges: {
            merge(_existing = [], incoming?: PriceRange[]) {
              return [...(incoming ?? [])]
            },
          },
          additionalServices: {
            merge(_existing = [], incoming?: AdditionalService[]) {
              return [...(incoming ?? [])]
            },
          },
          childRule: {
            merge(existing, incoming, { mergeObjects }) {
              return mergeObjects(existing, incoming)
            },
          },
        },
      },
      Reservation: {
        fields: {
          reference: {
            merge(existing, incoming, { mergeObjects }) {
              return mergeObjects(existing, incoming)
            },
          },
          origin: {
            merge(existing, incoming, { mergeObjects }) {
              return mergeObjects(existing, incoming)
            },
          },
        },
      },
      Customer: {
        fields: {
          address: {
            merge(existing, incoming, { mergeObjects }) {
              return mergeObjects(existing, incoming)
            },
          },
          privacy: {
            merge(existing, incoming, { mergeObjects }) {
              return mergeObjects(existing, incoming)
            },
          },
          person: {
            merge(existing, incoming, { mergeObjects }) {
              return mergeObjects(existing, incoming)
            },
          },
        },
      },
      Quotation: {
        fields: {
          reference: {
            merge(existing, incoming, { mergeObjects }) {
              return mergeObjects(existing, incoming)
            },
          },
          auditable: {
            merge(existing, incoming, { mergeObjects }) {
              return mergeObjects(existing, incoming)
            },
          },
        },
      },
      Property: {
        fields: {
          address: {
            merge(existing, incoming, { mergeObjects }) {
              return mergeObjects(existing, incoming)
            },
          },
        },
      },
      ReservedResource: {
        fields: {
          chargeCategory: {
            merge(existing, incoming, { mergeObjects }) {
              return mergeObjects(existing, incoming)
            },
          },
          policy: {
            merge(existing, incoming, { mergeObjects }) {
              return mergeObjects(existing, incoming)
            },
          },
        },
      },
      ResourceType: {
        fields: {
          name: {
            merge(existing, incoming, { mergeObjects }) {
              return mergeObjects(existing, incoming)
            },
          },
        },
      },
    },
  })
}
